import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isFilterChanged: false,

  sort: {
    element: null,
    order: null,
  },

  filters: {
    changed: false,
    status: 'pending',
    mode: 'all',
    outreach: [],
    schedule: null,
  },
};

const { reducer, actions } = createSlice({
  name: 'tasks',
  initialState,

  reducers: {
    applyFilter: (state, action) => {
      const { type, selected } = action.payload;
      state.filters[type] = selected;
      state.isFilterChanged = true;
      // Completed & Failed tabs shouldn't have schedule filter, even if set earlier, it needs to reset.
      if (
        type === 'status' &&
        (selected === 'completed' || selected === 'failed')
      ) {
        state.filters.schedule = null;
      }
    },
    clearFilter: (state, { payload }) => {
      // Hacky, currently only used for `flow filter`
      const { type, isMulti = false } = payload;
      state.filters[type] = isMulti ? [] : null;
    },
    applySort: (state, { payload }) => {
      const { element, order } = payload;
      state.sort.element = element;
      state.sort.order = order;
    },
    clearAllFilter: (state, { payload }) => {
      // clearAllFilter should only clear filters and not the selected tab, i.e pending, today or channel etc.
      // To retain the current selected tab and channel, we depend on the url params to determine it.
      state.filters = {
        ...initialState.filters,
        isFilterChanged: false,
        status: payload?.status,
        channel: payload?.channel,
      };
    },
  },
});

export default reducer;
export const { applyFilter, clearFilter, clearAllFilter, applySort } = actions;
